import { IOption } from '../../models/IOption';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ff-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {

  /**
   * Options to display as radio buttons
   * Use the IOption interface: { value: string; text: string; selected?: boolean; }
   * @internal
   */
  @Input() options: IOption[] = [];

  /**
   * Return the options updated each time the user check a radio button
   * @internal
   */
  @Output() updatedValues = new EventEmitter<IOption[]>();

  constructor() { }

  onSelect = (option: IOption): void => {
    option = {...option, selected: !option.selected};
    this.options = this.options.map(element => element.value === option.value
      ? {...element, checked: option.selected}
      : {...element, checked: false});

    this.updateValues();
  }

  /**
   * Return the updated array to the parent component
   */
  private updateValues = (): void => {
    this.updatedValues.emit(this.options);
  }
}
